import {
  jb_breadcrumbs_back_link_css_default
} from "./chunk.SOCM2OQV.js";
import {
  e as e2
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  Linkable
} from "./chunk.TC6HXM2Y.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  attachInterestEvents
} from "./chunk.AHMM4X2O.js";
import {
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  e,
  n,
  r
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-breadcrumbs-back-link/jb-breadcrumbs-back-link.ts
var JbBreadcrumbsBackLink = class extends Linkable(i) {
  constructor() {
    super(...arguments);
    this._hover = false;
  }
  async connectedCallback() {
    super.connectedCallback();
    await this.updateComplete;
    attachInterestEvents(this._backlink);
  }
  _mouseInHandler() {
    this._hover = true;
  }
  _mouseOutHandler() {
    this._hover = false;
  }
  render() {
    return b`
      <a
        data-linkable
        @interest=${this._mouseInHandler}
        @loseinterest=${this._mouseOutHandler}
        class="${e2({ hover: this._hover })}"
      >
        <span>${this.text}</span>
        <jb-icon
          size="small"
          iconName="material:west"
        ></jb-icon>
      </a>
    `;
  }
};
JbBreadcrumbsBackLink.styles = [reset_css_default, jb_breadcrumbs_back_link_css_default];
__decorateClass([
  n()
], JbBreadcrumbsBackLink.prototype, "text", 2);
__decorateClass([
  e("a")
], JbBreadcrumbsBackLink.prototype, "_backlink", 2);
__decorateClass([
  r()
], JbBreadcrumbsBackLink.prototype, "_hover", 2);
JbBreadcrumbsBackLink = __decorateClass([
  customElement("jb-breadcrumbs-back-link")
], JbBreadcrumbsBackLink);

export {
  JbBreadcrumbsBackLink
};
